export const run_filter_delay = 300; // in millisecconds